import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SiteSequencerComponent } from './components/site-sequencer/site-sequencer.component';

const routes: Routes = [
  { path: 'site-sequencer', component: SiteSequencerComponent },
  {
    path: 'equipment-builder',
    loadChildren: () => import('./modules/equipment-builder/equipment-builder.module').then(m => m.EquipmentBuilderModule)
  },
  { path: '', redirectTo: 'site-sequencer', pathMatch: 'full' },
  { path: '**', redirectTo: 'site-sequencer' }
];

@NgModule({
  // Initial navigation is triggered manually once AppComponent finishes
  // persisting query-param data (token/user details), avoiding a race
  // where routed components read stale LocalStorageService values.
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'disabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
